"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNicknameLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const use_lazy_promise_1 = require("../../../../hook/use-lazy-promise");
const log_1 = require("../../../../model/log");
const theme_1 = require("../../../../theme");
const button_1 = require("../../../../component/input/button");
const user_context_1 = require("../../../../context/user-context");
const alert_context_1 = require("../../../../context/alert-context");
const user_1 = require("../../../../network/user");
exports.UpdateNicknameLayout = (0, react_1.memo)(() => {
    const { userMeta } = (0, user_context_1.useUserMeta)();
    const { showAlert } = (0, alert_context_1.useAlert)();
    const [nickname, setNickname] = (0, react_1.useState)((userMeta === null || userMeta === void 0 ? void 0 : userMeta.nickname) || "");
    const { refresh: refreshUserMeta } = (0, user_context_1.useUserUpdate)();
    const { execute: updateUserMetaExecute, status: updateUserMetaStatus, error: updateUserMetaError, } = (0, use_lazy_promise_1.useLazyPromise)(user_1.updateUserMeta);
    const handleUpdateNicknameInput = (0, react_1.useCallback)((event) => {
        setNickname(event.target.value);
    }, []);
    const handleUpdateNickname = (0, react_1.useCallback)(() => {
        if (nickname) {
            updateUserMetaExecute({ nickname });
        }
    }, [nickname, updateUserMetaExecute]);
    (0, react_1.useEffect)(() => {
        if (updateUserMetaStatus === use_lazy_promise_1.FetchStatus.Success) {
            showAlert("Nickname updated successfully", alert_context_1.AlertType.Success);
            refreshUserMeta();
        }
        else if (updateUserMetaStatus === use_lazy_promise_1.FetchStatus.Error) {
            showAlert((updateUserMetaError === null || updateUserMetaError === void 0 ? void 0 : updateUserMetaError.message) || "Failed to update nickname", alert_context_1.AlertType.Error);
        }
    }, [updateUserMetaStatus, updateUserMetaError, refreshUserMeta, showAlert]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", justifyContent: "flex-end", spacing: 2, width: "100%", children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { variant: "outlined", size: "small", value: nickname, onChange: handleUpdateNicknameInput }), (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", color: "primary", eventName: log_1.LogEventClickName.UpdateNickname, sx: {
                    width: theme_1.theme.spacing(10),
                }, onClick: handleUpdateNickname, disabled: updateUserMetaStatus === use_lazy_promise_1.FetchStatus.Loading || !nickname, startIcon: updateUserMetaStatus === use_lazy_promise_1.FetchStatus.Loading ? ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: 20 })) : null, children: "Save" })] }));
});
exports.UpdateNicknameLayout.displayName = "UpdateNicknameLayout";
